/**
 *
 * @param requestData
 * @param errorData
 * @description This function takes in two parameters: `requestData` and `errorData`.
 * It checks if both parameters are defined and if `errorData` is an object.
 * If the conditions are met, it creates a new object `result` and iterates over the keys of `errorData`.
 * For each key, it checks if the key exists in `requestData`.
 * If it does, it assigns the value from `requestData` to `result`, replacing the value of the key 'password' with '****'.
 * @returns {Record<string, unknown>} - The resulting object with the filtered data or undefined.
 */
export const requestDataUtil = (
  requestData: Record<string, unknown> | undefined,
  errorData: any
) => {
  if (!(requestData && errorData)) return;
  if (typeof errorData !== 'object' || Array.isArray(errorData)) return;

  const result: Record<string, unknown> = {};
  Object.keys(errorData).forEach((key) => {
    if (key in requestData) {
      result[key] = key === 'password' ? '****' : requestData[key];
    }
  });

  return result;
};
